import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Loading from "./components/shared/Loading";
import { useFetchMeQuery } from "./store";

const PrivateRoute = () => {
  const token = localStorage.getItem("access-token");
  const { data: user, isLoading, isError } = useFetchMeQuery();
  if (isLoading) return <Loading isLoading={isLoading} />;
  if (isError || !token) return <Navigate to="/signin" />;
  if (token && user !== null) return <Outlet />;
  return <Navigate to="/signin" />;
};

export default PrivateRoute;
